// Mapping status_intelijen → label UI (dependent ke bahasa aktif).
// DB value TETAP: 'CLEAR' | 'WATCHLIST' | 'SUSPECT' | 'WANTED' (canonical).
// UI label berbeda agar tidak rancu (CLEAR mirip tombol "Clear/Bersihkan").
//
// Contoh: getIntelLabel('CLEAR', 'id') → 'AMAN'
//         getIntelLabel('CLEAR', 'en') → 'SAFE'
import translations from '../data/i18n';

const KEY_MAP = {
  CLEAR:     'intel_clear',
  WATCHLIST: 'intel_watchlist',
  SUSPECT:   'intel_suspect',
  WANTED:    'intel_wanted',
};

export function getIntelLabel(status, lang = 'id') {
  if (!status) return translations[lang]?.intel_clear ?? 'AMAN';
  const key = KEY_MAP[status];
  if (!key) return status;
  return translations[lang]?.[key] ?? status;
}

// Color mapping (visual constant — tidak tergantung bahasa)
export const INTEL_COLORS = {
  CLEAR:     { color: '#00ff88', bg: 'rgba(0,255,136,0.10)', bd: 'rgba(0,255,136,0.35)' },
  WATCHLIST: { color: '#ffd60a', bg: 'rgba(255,214,10,0.10)', bd: 'rgba(255,214,10,0.4)' },
  SUSPECT:   { color: '#ff6b2b', bg: 'rgba(255,107,43,0.12)', bd: 'rgba(255,107,43,0.5)' },
  WANTED:    { color: '#ff2d55', bg: 'rgba(255,45,85,0.12)',  bd: 'rgba(255,45,85,0.5)'  },
};

export function getIntelColor(status) {
  return INTEL_COLORS[status] || INTEL_COLORS.CLEAR;
}
